import cx from 'classnames';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import type { BlockViewProps } from '@plone/types';

import styles from '@redturtle/qubicaamf-theme/components/Blocks/PageIntro/styles.module.css';
import './pageintro.scss';
import type { PageIntroData } from '@redturtle/qubicaamf-theme/components/Blocks/PageIntro/schema';

import config from '@plone/registry';
import CTA from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA';

type Props = BlockViewProps & {
  data: PageIntroData;
};

export default function View({ data, className, style }: Props) {
  const Container = config.getComponent('Container').component || 'div';

  return (
    <section
      className={cx('block-pageintro', styles.block, className)}
      style={style}
      aria-label={data.title}
    >
      <Container className={cx('block-pageintro-container', styles.container)}>
        <div className={cx('block-pageintro-narrow-col', styles.narrow)}>
          {data.title && (
            <h2 className={cx('block-pageintro-title', styles.title)}>
              {data.title}
            </h2>
          )}
        </div>
        <div className={cx('block-pageintro-wide-col', styles.wide)}>
          {data.text && (
            <div className={cx('block-pageintro-text', styles.text)}>
              <TextBlockView data={{ value: data.text ?? {} }} />
            </div>
          )}
          {data.linkHref?.[0] && (
            <CTA
              href={data.linkHref[0]['@id']}
              openLinkInNewTab={false}
              ctaButtonStyle={data.ctaButtonStyle}
              linkIcon={data.linkIcon}
              cta_color={data.cta_color}
            >
              {data.linkTitle}
            </CTA>
          )}
        </div>
      </Container>
    </section>
  );
}
